export const BOOKMARK_CHART_COLORS_PANEL = [

    // BLUE
    "#1D4ED8",
    "#3B82F6",
    "#60A5FA",
    "#93C5FD",

    // EMERALD
    "#047857",
    "#10B981",
    "#34D399",
    "#6EE7B7",

    // AMBER
    "#B45309",
    "#F59E0B",
    "#FBBF24",
    "#FCD34D",

    // RED
    "#B91C1C",
    "#EF4444",
    "#F87171",
    "#FCA5A5",

    // VIOLET
    "#6D28D9",
    "#8B5CF6",
    "#A78BFA",
    "#C4B5FD",

    // PINK
    "#BE185D",
    "#EC4899",
    "#F472B6",
    "#F9A8D4",

    // SLATE / GRAY
    "#111827",
    "#374151",
    "#6B7280",
    "#9CA3AF",

    // BROWN
    "#78350F",
    "#92400E",
    "#B45309",
    "#D97706",

    // TEAL
    "#0F766E",
    "#14B8A6",
    "#2DD4BF",
    "#99F6E4",

    // INDIGO
    "#3730A3",
    "#6366F1",
    "#818CF8",
    "#C7D2FE",

    // CYAN
    "#0E7490",
    "#06B6D4",
    "#67E8F9",
    "#CFFAFE",

    // LIME
    "#4D7C0F",
    "#84CC16",
    "#A3E635",
    "#D9F99D",

    // ORANGE
    "#C2410C",
    "#F97316",
    "#FB923C",
    "#FED7AA"
];

export function interleaveColorSeries(
    colors,
    shadeOrder = [0, 1, 2, 3]
) {
    const shadesPerSeries = shadeOrder.length;
    const seriesCount = colors.length / shadesPerSeries;

    if (!Number.isInteger(seriesCount)) {
        throw new Error(
            "colors length is not compatible with shadeOrder length"
        );
    }

    if (shadeOrder.some(i => i >= shadesPerSeries || i < 0)) {
        throw new Error(
            "shadeOrder contains invalid shade indexes"
        );
    }

    return shadeOrder.flatMap((shadeIndex) =>
        Array.from({ length: seriesCount }, (_, seriesIndex) => {
            return colors[
            seriesIndex * shadesPerSeries + shadeIndex
                ];
        })
    );
}
export const BOOKMARK_CHART_COLORS = interleaveColorSeries(BOOKMARK_CHART_COLORS_PANEL);
export const BOOKMARK_CHART_COLORS_REORDERED = interleaveColorSeries(BOOKMARK_CHART_COLORS_PANEL, [1, 2, 3, 0]);
